import { useContext } from 'react';
import { Row, Col } from 'reactstrap';
import FindToolLead from './FindToolLead';
import LearningContext from '_helper/Leatning';

const ToolLeadFilter = () => {
	const { isOpen, setIsOpen } = useContext(LearningContext);
	const onClickHandel = () => {
		setIsOpen(!isOpen);
	};

	return (
		<Col xl="3 xl-20">
			<div className="job-sidebar md-sidebar">
				<a className="btn btn-primary md-sidebar-toggle" href="#javascript" onClick={onClickHandel}>
					Filter Lead
				</a>
				<div className={`md-sidebar-aside job-left-aside custom-scrollbar ${isOpen ? 'open' : ''}`}>
					<div className="default-according style-1 faq-accordion job-accordion" id="accordionoc">
						<Row>
							<FindToolLead />
						</Row>
					</div>
				</div>
			</div>
		</Col>
	);
};

export default ToolLeadFilter;
